<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-marketing"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="modal-base-body">
                    <div class="page-wrapper">
                        <div class="page-bg"></div>
                        <div class="page-content">
                            <TopBarDark
                                :title="lbl.static.marketing.title_topbar"
                                @clickBack="clickBack()">
                            </TopBarDark>
                            <div class="marketing-page">
                                <div class="wrapper-marketing">
                                    <div class="text-detail" v-html="maketingContent"></div>
                                </div>
                                <div class="title-msg" v-html="lbl.static.marketing.tile_msg"></div>
                                <div>
                                    <InputToggle
                                            v-model="isAll"
                                            :inputLbl="lbl.static.marketing.all"
                                            :all="true"
                                            @onClickAll="onClickAll($event)" />
                                    <InputToggle
                                            v-model="isEmail"
                                            :inputLbl="lbl.static.marketing.email"
                                            :email="true"
                                            @onAcceptEmail="onAcceptEmail($event)" />
                                    <InputToggle
                                            v-model="isSMS"
                                            :inputLbl="lbl.static.marketing.sms"
                                            :sms="true"
                                            @onAcceptSMS="onAcceptSMS($event)" />
                                    <InputToggle
                                            v-model="isLine"
                                            :inputLbl="lbl.static.marketing.line"
                                            :line="true"
                                            @onAcceptLine="onAcceptLine($event)" />
                                </div>
                                <div class="btn-accept" v-if="toggle"  @click="clickOk()">
                                    <div class="btn-txt">
                                        {{lbl.static.marketing.btn_accept}}
                                    </div>
                                </div>

                                <div class="btn-accept disabled" v-else>
                                    <div class="btn-txt">
                                        {{lbl.static.marketing.btn_accept}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">

                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import TopBarDark from "@/components/Layout/TopBarPage/TopBarDark.vue"
import InputToggle from "../../../Input/InputToggle.vue";
//service
import PDPAService from "@/core/PDPA/service/BzbsPDPA.js";
import { PDPAModel } from '@/core/PDPA/model/PDPAModel.js';
/**
 * @property {ProductDescriptionModalController} controller (required)../Controller/ProductDescriptionModalController.js
 * @property {String} modalId (reqquired)
 */

export default {
    name: "MarketingModal",
    props: {
        controller: Object,
        modalId: String,
        loadingModal: Object, //loding modal from master controller
    },
    components: {
        TopBarDark,
        InputToggle
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    data: function() {
        return {
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            busModal: null,
            maketingContent: null,

            isAll: true,
            isEmail: true,
            isSMS: true,
            isLine: true,
            isNotification: true,
            termsVersion: 1,
            privacyVersion: 1,
            marketingVersion: null,

            toggle: true,

            isMarketing: null,
            clickAll: null,

            infoMarketing: ''
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
        this.infoMarketing = this.lbl.static.marketing.detail4;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
        this.busModal.$on('setMarketing', this.setMarketing);
    },
    methods: {
        onOk: function () {
            this.hide();

            if (this.tag == 'profile') {
                this.submitConsent();
            } else {
                let marketing = {
                    all: this.isAll,
                    email: this.isEmail,
                    sms: this.isSMS,
                    line: this.isLine,
                }
                this.controller.sendCallbackOk(marketing);
            }
        },
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            this.onOk();
        },
        clickBack: function(){
            this.hide();
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;

            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            if (this.tag == 'box-consent') {
                this.isAll = true;
                this.isEmail = true;
                this.isSMS = true;
                this.isLine = true;
                this.toggle = true;
            } else {
                this.toggle = false;
            }
            if (this.tag == 'profile') {
                this.getMarketing();
            }

            this.getPDPAVesion();
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        getMarketing: function () {
            var token = this.getToken();
            return new Promise((resolve, reject) => {
                PDPAService.apiGetNewConsent(token).subscribe((data) => {
                    resolve(data);
                    data.EmailMarketing == 0 ? this.isEmail = false : this.isEmail = true;
                    data.SMSMarketing == 0 ? this.isSMS = false : this.isSMS = true;
                    data.LineMarketing == 0 ? this.isLine = false : this.isLine = true;
                    this.onAcceptEmail(this.isEmail);
                    this.onAcceptSMS(this.isSMS);
                    this.onAcceptLine(this.isLine);
                }, (err) => {
                    reject(err);
                });
            });
        },
        getPDPAVesion: function () {
            return new Promise((resolve, reject) => {
                PDPAService.apiGetPDPAVersion().subscribe((data) => {
                    resolve(data);
                    this.marketingVersion = data.marketing;
                    this.getMarketingContent(this.marketingVersion);
                }, (err) => {
                    reject(err);
                });
            });
        },
        getMarketingContent: function (version) {
            return new Promise((resolve, reject) => {
                PDPAService.apiGetPDPAContent("marketing", version, this.localeCode).subscribe((data) => {
                    resolve(data);
                    this.maketingContent = data;
                }, (err) => {
                    reject(err);
                });
            });
        },
        onAcceptEmail: function (data) {
            this.isEmail = data;
            if (this.isEmail && this.isSMS && this.isLine) {
                this.isAll = true;
            } else {
                this.isAll = false;
            }
            this.checkBtnAccept();
        },
        onAcceptSMS: function (data) {
            this.isSMS = data;
            if (this.isEmail && this.isSMS && this.isLine) {
                this.isAll = true;
            } else {
                this.isAll = false;
            }
            this.checkBtnAccept();
        },
        onAcceptLine: function (data) {
            this.isLine = data;
            if (this.isEmail && this.isSMS && this.isLine) {
                this.isAll = true;
            } else {
                this.isAll = false;
            }
            this.checkBtnAccept();
        },
        onClickAll: function (all) {
            if (all) {
                this.isAll = true;
                this.isEmail = true;
                this.isSMS = true;
                this.isLine = true;
                this.toggle = true;
            } else {
                this.isAll = false;
                this.isEmail = false;
                this.isSMS = false;
                this.isLine = false;
                if (this.tag == 'profile') {
                    this.toggle = true;
                } else {
                    this.toggle = false;
                }
            }
        },
        checkBtnAccept: function() {
            if (this.isAll || this.isEmail ||
                this.isSMS || this.isLine) {
                this.toggle = true;
            } else {
                this.toggle = false;
            }
            if (this.tag == 'profile') {
                this.toggle = true;
            }
        },
        setMarketing: function(data){
            if (!data) return;

            this.isAll = data.all
            this.isEmail = data.email;
            this.isSMS = data.sms;
            this.isLine = data.line;
        },
        submitConsent: function(){
            //Save Consent
            var token = this.getToken();
            let consentModel = new PDPAModel();
            var consent = {
                termandcondition: this.termsVersion,
                dataprivacy: this.privacyVersion,
                consentAge: 20,
                email: this.isEmail,
                sms: this.isSMS,
                notification: this.isNotification,
                line: this.isLine,
                marketingOption: this.marketingVersion
            }
            consentModel.setPDPAModel(consent);
            let params = consentModel.getParams();
            this.controller.loadingModal.show();
            PDPAService.apiPostConsent(token, params)
                .subscribe((result) => {
                    console.log(result);
                    this.controller.loadingModal.hide();
                    this.controller.alertModal.clearText()
                                              .setTitle(this.lbl.static.marketing.title_alert)
                                              .setMsg(this.lbl.static.marketing.detail_text)
                                              .setBtnOk(this.lbl.static.marketing.btn_close)
                                              .setTheme('gray')
                                              .show()
                },(error) => {
                    this.controller.loadingModal.hide();
                    console.log(error);
                });
        },
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseText.scss";
@import "@/style/base/baseDisplay.scss";
@import '@/style/input/BaseButton.scss';
.modal-marketing{
    .page-wrapper {
        .page-bg {
            background-color: $white;
        }
    }
    .marketing-page {
        @include bg-curve();
        position: absolute;
        bottom: unset;
        padding: 30px 25px 10px;
        word-wrap: break-word;

        .wrapper-marketing {
            background-color: $light-blue;
            border-radius: 30px;
            width: 100%;
            height: 422px;
            overflow-y: auto;
            @include scrollbar($pink, white);

            .text-detail {
                font-size: 1.1rem;
                line-height: 1.56;
                text-align: left;
                font-size: 18px;
                line-height: 1.56;
                margin: 15px 37px 20px 32px;
                color: $black;

                @include mini-mobile(){
                    font-size: 0.9rem;
                }
            }
        }
        .title-msg {
            font-size: 1.125rem;
            color: $black;
            text-align: center;
            margin: {
                top: 20px;
                bottom: 30px;
            }
        }
        .btn-accept{
            @include btn-wrapper();
            margin: 30px auto 20px;

            &:disabled {
                opacity: 0.3;
            }

            @include mini-mobile(){
                min-height: 40px;
            }

        }
    }
}

</style>

<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-marketing{
    .modal-dialog{
        margin: 0;

        .modal-content{
            border: 0;

            .modal-body{
                padding: 0;
            }
        }
    }
}
</style>
